module.exports = __webpack_public_path__ + "images/quantity-error1c54ad5588d8c6ed242319da4fe798c2.svg";